import { render } from "./profile-form.vue?vue&type=template&id=7b0f1132&scoped=true"
import script from "./profile-form.vue?vue&type=script&lang=js"
export * from "./profile-form.vue?vue&type=script&lang=js"

import "./profile-form.vue?vue&type=style&index=0&id=7b0f1132&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b0f1132"]])

export default __exports__